import { Component, Input } from '@angular/core';

import { Tier } from '../models';

@Component({
    selector: 'app-tier-price',
    templateUrl: './tier-price.component.html',
    styleUrls: ['./tier-price.component.scss'],
})
export class TierPriceComponent {
    @Input() tier: Tier;
}
